import { combineReducers } from 'redux';

import estimateSummaryReducer from '../estimateSummary/store/reducer';
import trgReducer from '../trg/store/reducer';

export default combineReducers({
  estimateSummary: estimateSummaryReducer,
  trg: trgReducer,
});
